import { render, staticRenderFns } from "./OperatingHours.vue?vue&type=template&id=ae11dae0&scoped=true&"
import script from "./OperatingHours.vue?vue&type=script&lang=js&"
export * from "./OperatingHours.vue?vue&type=script&lang=js&"
import style0 from "./OperatingHours.vue?vue&type=style&index=0&id=ae11dae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae11dae0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae11dae0')) {
      api.createRecord('ae11dae0', component.options)
    } else {
      api.reload('ae11dae0', component.options)
    }
    module.hot.accept("./OperatingHours.vue?vue&type=template&id=ae11dae0&scoped=true&", function () {
      api.rerender('ae11dae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/OperatingHours.vue"
export default component.exports